import React from "react";
import { defineMessages } from "react-intl";
import moment from "moment-timezone";
import { LocalizedText } from "../../../i18n/LocalizedText.js";
import { EmptyLabel } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import { timestampSecondsToMoment } from "../../../../utils/date.js";
const localized = defineMessages({
  day: {
    id: "DurationCell_day",
    defaultMessage: "{value} day"
  },
  days: {
    id: "DurationCell_days",
    defaultMessage: "{value} days"
  }
});
function DurationCell({ timestamp, count }) {
  const value = Math.abs(timestampSecondsToMoment(timestamp?.seconds)?.diff(moment.utc().endOf("day"), "days") ?? count);
  const localizedLabel = value === 1 ? localized.day : localized.days;
  return value ? /* @__PURE__ */ React.createElement(LocalizedText, { label: localizedLabel, labelParams: { value } }) : /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" });
}
export {
  DurationCell
};
//# sourceMappingURL=DurationCell.js.map
